import React, { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import blog_1 from "../assets/Images/blog_1.jpg"
import blog_2 from "../assets/Images/blog_2.jpg"
import blog_3 from "../assets/Images/blog_3.jpg"
const articles = [
  {
    id: 1,
    title: 'What Makes MagnAid Hospitals Hyderabads Trusted Surgery Experts',
    category: 'News & Updates',
    date: 'April 10, 2025',
    image: blog_1,
    link: 'https://www.instagram.com/p/DIRArcXyOl7/?img_index=1'
  },
  {
    id: 2,
    title:
      'Piles vs Fissures vs Fistula:  Basics Explained',
    category: 'News & Updates',
    date: 'April 24, 2025',
    image: blog_2, link: 'https://www.instagram.com/p/DI0NJhfyrfs/?img_index=1'
  },
  {
    id: 3,
    title: 'What to Consider When Trying to Rehydrate in Summer',
    category: 'Tips',
    date: 'May 2, 2025',
    image: blog_3, link: 'https://www.instagram.com/p/DJLddJiSavK/'
  }
]

export default function HomeArticles() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);
  return (
    <div className='py-[90px] md:py-[240px] max-w-[1340px] mx-auto px-[24px] md:px-[24px] xl:px-[0px]'>
      {/* Header Section */}
      <div className='block md:flex' data-aos="fade-up" >
        <h2 className='  text-[36px] md:text-[48px] lg:text-[58px] leading-[1.138em] font-heading text-thickGreen mb-[48px] max-w-[450px] lg:max-w-[650px]'>
          MagnAid Chronicles- empowering health & wellness
        </h2>
        <div className='ms-auto flex justify-center items-center '>
          <a
            href='/'
            className='text-thickGreen hover:bg-orange w-full  px-6 py-6 rounded-full font-medium border border-lightGreen bg-transparent flex justify-center items-center hover:border-none hover:text-white text-[20px] leading-[1.112em] transition-all duration-300 hover:-translate-y-1 font-body'
          >
            Browse all Articles
          </a>
        </div>
      </div>

      {/* Articles Grid */}
      <div className='grid grid-cols-1 lg:grid-cols-3 gap-8 mt-10 md:mt-0 ' data-aos="fade-up" data-aos-delay="300">
        {articles.map(article => (
          <div key={article.id} className='rounded-[16px] overflow-hidden relative'>
            <img
              src={article.image}
              alt={article.title}
              className='w-full rounded-[16px] transition-transform duration-300 hover:scale-105 mb-[24px]'
            />
            <div className='mt-4'>
              <p className='font-medium text-paraGreen hover:text-thickGreen cursor-pointer text-[22px] leading-[1.273em] font-heading mb-[24px] pb-4'>
                <a href={`${article?.link}`} target='_blank' rel="noreferrer">
                  {article.title}
                </a>
              </p>
              <p className='text-gray-500 mt-2 absolute bottom-0'>
                <span className='text-gray-700 font-semibold font-body'>
                  {article.category}
                </span>{' '}
                — {article.date}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
